import React, { useEffect } from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaExclamationCircle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import './SalesforceToast.css';

const SalesforceToast = ({
  show,
  message,
  type = 'success', // success, error, warning, info
  onClose,
  duration = 5000,
  position = 'top-center' // top-center, top-right, top-left
}) => {
  useEffect(() => {
    console.log('SalesforceToast props:', { show, message, type, position });
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        if (onClose) onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose, message, type, position]);

  if (!show) {
    console.log('SalesforceToast: Not showing (show=false)');
    return null;
  }

  console.log('SalesforceToast: Rendering toast with message:', message);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="sf-toast-icon" />;
      case 'error':
        return <FaExclamationCircle className="sf-toast-icon" />;
      case 'warning':
        return <FaExclamationTriangle className="sf-toast-icon" />;
      case 'info':
        return <FaInfoCircle className="sf-toast-icon" />;
      default:
        return <FaCheckCircle className="sf-toast-icon" />;
    }
  };

  const getTitle = () => {
    switch (type) {
      case 'success':
        return 'Success';
      case 'error':
        return 'Error';
      case 'warning':
        return 'Warning';
      case 'info':
        return 'Info';
      default:
        return 'Success';
    }
  };

  return (
    <div className={`sf-toast-container sf-toast-${position}`}>
      <div className={`sf-toast sf-toast-${type}`}>
        <div className="sf-toast-content">
          <div className="sf-toast-icon-wrapper">
            {getIcon()}
          </div>
          <div className="sf-toast-message">
            <div className="sf-toast-title">{getTitle()}</div>
            <div className="sf-toast-text">{message}</div>
          </div>
          <button
            className="sf-toast-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalesforceToast;
